import log from "loglevel";
import { get, set } from "./global";
export class SkipSetting {
    constructor() {
        this.skipScene = false;
        this.skipDelay = false;
    }
    skipAll() {
        this.skipScene = true;
        this.skipDelay = true;
        $(document).on("play", (ev) => {
            log.trace("something is played", ev);
        });
    }
    async asyncRunScene(promiseMaker) {
        if (this.skipScene) {
            return null;
        }
        else {
            return await promiseMaker();
        }
    }
    async asyncRunSceneOr(promiseMaker, or) {
        if (this.skipScene) {
            return await or();
        }
        else {
            return await promiseMaker();
        }
    }
    async asyncRunSkippable(promiseMaker) {
        if (this.skipDelay) {
            return;
        }
        else {
            await promiseMaker();
        }
    }
    async asyncRunSkippableOr(promiseMaker, or) {
        if (this.skipDelay) {
            await or();
        }
        else {
            await promiseMaker();
        }
    }
    getSkippableTimeInMS(milliseconds) {
        if (this.skipDelay) {
            return 1;
        }
        else {
            return milliseconds;
        }
    }
    toggleSkipDelay() {
        this.skipDelay = !this.skipDelay;
        $(document).trigger("skipChange");
        if (this.skipDelay) {
            alert("스킵이 설졍되었습니다.");
        }
        else {
            alert("스킵을 취소합니다.");
        }
    }
}
export function getSkip() {
    let skip = get("skip");
    if (!skip) {
        skip = new SkipSetting();
        set("skip", skip);
    }
    return skip;
}
//# sourceMappingURL=skipper.js.map